import {Component, Input, Output, EventEmitter, OnInit, HostListener} from '@angular/core';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.html'
})
export class ConfirmPopupComponent implements OnInit {
  @Input() data: any;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();


  @HostListener('window:keyup', ['$event']) onKey(event) {
    if (event.keyCode === 27) {
      this.onClose();
    } else if ([32, 13].indexOf(event.keyCode) >= 0) {
      this.onSuccess();
    }
  }

  constructor() {
  }

  ngOnInit() {
  }

  onClose() {
    if (this.data && !this.data.disableClose) {
      if (this.data.type === 'changePerson') {
        this.notify.emit({
          type: 'close',
          data: this.data
        });
        return true;
      }
      this.notify.emit({
        type: 'close',
        data: this.data
      });
    }
  }

  onSuccess(recreate?: boolean) {
    if (this.data && !this.data.disableClose) {
      if (this.data.type === 'changePerson') {
        this.notify.emit({
          type: 'success',
          data: this.data
        });
        return true;
      }

      this.notify.emit({
        type: this.data.recreateUser ? (recreate ? 'recreate' : 'createNew') : 'success',
        data: this.data
      });
    }
  }
}
